export const config = {
    apiURLs: {
        register: { method: 'POST', endPoint: '/api/auth/register' },
        verifyEmail: { method: 'POST', endPoint: '/api/auth/verify-otp' },
        login: { method: 'POST', endPoint: '/api/auth/login' },
        invite: { method: 'POST', endPoint: '/api/auth/invite' , isAlert: true},
        verifyInvite: { method: 'POST', endPoint: '/api/auth/verify-invite-token' },
        forgotPassword: {method: 'POST', endPoint:'/api/auth/forgotPassword',isAlert: true},
        resetPassword: {method: 'POST', endPoint:'/api/auth/resetPassword'},
        resendOTP: {method: 'POST', endPoint:'/api/auth/resendOTP'},

        // client management
        createClient: {method: 'POST', endPoint: '/api/client/createClients/'},
        getClientByID: {method: 'GET', endPoint: '/api/client/getClientsbyID/'},
        getClients: {method: 'GET', endPoint: '/api/client/getClients/'},
        deleteClient: {method: 'GET', endPoint: '/api/client/deleteClients/', isAlert: true},

        // case management
        getClientsDropdown: {method: 'GET', endPoint: '/api/case/getClients/', isAlert: false},
        getLawers: {method: 'GET', endPoint: '/api/case/getLawers/', isAlert: false},
        createCase: {method: 'POST', endPoint: '/api/case/createCase/', isAlert: true},
        getAllCase: {method: 'GET', endPoint: '/api/case/getAllCase/', isAlert: false},
        getCaseByID: {method: 'GET', endPoint: '/api/case/getCaseByID/', isAlert: false},
        getFullCaseDetails: {method: 'GET', endPoint: '/api/case/getFullCaseDetails/'},

        //lawyer module
        getAllLawyer: { method: 'GET', endPoint: '/api/lawyer/lawyer-list/'},
        deleteLawyer: { method: 'DELETE', endPoint: (id) => `/api/lawyer/lawyer/${id}` },
        getCaseForDropDown: {method: 'GET', endPoint: '/api/case/getCaseForDropDown'},

        //Hearing Management
        createHearing: {method: 'POST', endPoint: '/api/hearing/createHearing', isAlert: true},
        getHearings: {method: 'GET', endPoint: '/api/hearing/getHearings/'},
        getClosedHearings: {method: 'GET', endPoint: '/api/hearing/getClosedHearings'},

        // profile
        getProfileDetails: {method: 'GET', endPoint: '/api/profile/getProfileDetails'},
        updateProfileDetails: {method: 'POST', endPoint: '/api/profile/updateProfileDetails'},
        updateCompanyDetails: {method: 'POST', endPoint: '/api/profile/updateCompanyDetails'},
        changePassword: {method: 'POST', endPoint: '/api/profile/changePassword', isAlert: true},

        // dashboard
        getCaseLawyersCount: {method: 'GET', endPoint: '/api/dashboard/getCaseLawyersCount'},
        getCalendarData: {method: 'GET', endPoint: '/api/dashboard/getCalendarData'},

        //admin
        getCompanyList: {method: 'GET', endPoint: '/api/admin/getCompanyList'},
        updateCompanyDetails: {method: 'POST', endPoint: '/api/admin/updateCompanyDetails',isAlert: true},
        
    },
    endPoints: {

    }
}